import styles from "../styles/contact.module.css"
import getImgUrl from "../helper/getImgUrl";

const CONTACT_DATA = {
    main_photo: "/img/mainphoto-1758578007231-210425894.jpg",
    title: "Visit Our Workshop",
    experience: "Over a decade of experience crafting custom hardwood furniture for homeowners, architects, and interior designers across Eastern Canada.",
    address: "7558 Cronk Side Rd, Ramara, ON L0K 2B0",
    hours: "Mon – Fri: 9am – 5pm  |  Sat: 10am – 3pm  |  Sun: Closed",
    email: "info@thewetlandshop.com",
    subject: "General Inquiry",
};

const Contact = () => {
    return (
        <div className={styles.main_body}>
            <div className={styles.contact}>
                <h1>contact</h1>
            </div>
            <div className={styles.info}>
                <div className={styles.category}>
                    <p>contact us</p>
                </div>
                <div className={styles.contactInfo}>
                    <div className={styles.inquiry}>
                        <p>For all other inquiries or customer service questions</p>
                        <a href={`mailto:${CONTACT_DATA.email}?subject=${CONTACT_DATA.subject}`}>{CONTACT_DATA.email}</a>
                    </div>
                    <div className={styles.data}>
                        <h2>{CONTACT_DATA.title}</h2>
                        <p>{CONTACT_DATA.experience}</p>
                        <p className={styles.address}>{CONTACT_DATA.address}</p>
                        <p>{CONTACT_DATA.hours}</p>
                        <a href={`mailto:${CONTACT_DATA.email}?subject=${CONTACT_DATA.subject}`}><button>Book appointment</button></a>
                    </div>
                </div>
                <div className={styles.contactImg}>
                    <img src={getImgUrl(CONTACT_DATA.main_photo)} alt=""/>
                </div>
            </div>
        </div>
    )
}

export default Contact
